import { SVGProps } from 'react';

const Corner = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="13"
        height="24"
        viewBox="0 0 13 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        strokeWidth={1.5}
        style={{ strokeLinejoin: 'round', strokeMiterlimit: 2 }}
        {...props}
    >
        <line
            x1={1.5}
            y1={1.5}
            x2={12}
            y2={11}
            strokeLinecap="round"
        />
        <line
            x1={12}
            y1={11}
            x2={12}
            y2={22.5}
            strokeLinecap="round"
        />
        <line
            x1={1}
            y1={5}
            x2={1}
            y2={1}
            strokeLinecap="round"
        />
        <line
            x1={1}
            y1={1}
            x2={5}
            y2={1}
            strokeLinecap="round"
        />
    </svg>
);

export default Corner;
